import React, { Component } from "react";

// CSS
import "../../styles/newDesign.scss";
import "./Gallery.scss";

// Components
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

// Helper
import { apiFetch, resolveTenant } from "../../Helper/Api";

// Properties
const properties = require("../../properties.json");

class Gallery extends Component {
  state = {
    tenant: null,
    notFound: false,
    projects: [],
    loading: true,
    openIndex: null,
  };

  componentDidMount() {
    resolveTenant()
      .then((tenant) => {
        document.title = tenant.name ? `Gallery | ${tenant.name}` : properties.site_name;
        this.setState({ tenant });
        return apiFetch("/gallery-projects", { query: { branchId: tenant.branchId } });
      })
      .then((projects) => this.setState({ projects: projects || [], loading: false }))
      .catch(() => this.setState({ notFound: true, loading: false }));
  }

  openProject = (index) => this.setState({ openIndex: index });
  closeModal = () => this.setState({ openIndex: null });

  render() {
    const { tenant, notFound, projects, loading, openIndex } = this.state;

    if (notFound) {
      return (
        <div className="page">
          <div className="container text-center">
            <p>No page was found for this domain.</p>
          </div>
        </div>
      );
    }

    if (!tenant) return null;

    const project = openIndex !== null ? projects[openIndex] : null;

    return (
      <>
        <Header tenant={tenant} />

        <div className="nd-page">
          <div className="nd-hero">
            <div className="nd-wrap">
              <div className="nd-eyebrow">Our Work</div>
              <h1>Gallery</h1>
              <p>A selection of projects from our studio. Open any project to see the full set of photos and behind-the-scenes videos.</p>
            </div>
          </div>

          <div className="nd-section nd-wrap">
            {!loading && projects.length === 0 ? (
              <p style={{ color: "var(--nd-muted)" }}>No projects added yet.</p>
            ) : (
              <div className="gallery-grid">
                {projects.map((proj, i) => (
                  <div
                    className="gallery-tile"
                    key={proj.id}
                    onClick={() => this.openProject(i)}
                    style={proj.photos && proj.photos[0] ? { backgroundImage: `url(${proj.photos[0]})`, backgroundSize: "cover", backgroundPosition: "center" } : undefined}
                  >
                    <div className="gt-info">
                      {proj.tag && <div className="gt-tag">{proj.tag.split(" · ")[0]}</div>}
                      <h3>{proj.title}</h3>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className={`nd-page wg-modal-overlay ${project ? "open" : ""}`} onClick={(e) => e.target === e.currentTarget && this.closeModal()}>
          {project && (
            <div className="wg-modal-box">
              <button className="wg-modal-close" onClick={this.closeModal}>✕</button>
              <h2>{project.title}</h2>
              {project.tag && <div className="wg-modal-tag">{project.tag}</div>}
              <div className="wg-modal-photos">
                {(project.photos || []).map((url, k) => (
                  <div key={k} style={{ backgroundImage: `url(${url})`, backgroundSize: "cover", backgroundPosition: "center" }}></div>
                ))}
              </div>
              {project.videoUrl && (
                <div className="wg-modal-video">
                  <h4>Project Video</h4>
                  <video src={project.videoUrl} controls style={{ width: "100%", borderRadius: 14, display: "block", maxHeight: 280 }} />
                </div>
              )}
            </div>
          )}
        </div>

        <Footer tenant={tenant} />
      </>
    );
  }
}

export default Gallery;
